





































































































import {Component, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {ListVisualizationModeSchema} from '@/schema/resource/VisualizationMode/ListVisualizationModeSchema'
import {VisualizationModeCollection} from '@/model/collection/VisualizationModeCollection'
import {VisualizationMode} from '@/model/resource/VisualizationMode'

@Component
export default class ListVisualizationModeView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListVisualizationModeSchema()
  collection = new VisualizationModeCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: VisualizationMode) {
    Helper.pushByName('editInternacionalVisualizationMode', item.$id)
  }
}
